import React, { useState, useEffect } from "react";

import {
  Box,
  TextField,
  Button,
  Typography,
  Stack,
  Alert,
} from "@mui/material";

import BlogBodyEditor from "./BlogBodyEditor.jsx";

const STATUS_OPTIONS = ["draft", "review", "published", "archived"];

const initialForm = {
  overline: "",
  headline: "",
  teaser: "",
  body: "",
  status: "draft",
  published: false,
  published_at: "",
  authors: [],
  roles: [],
};

export default function BlogPostForm({
  initialValues = initialForm,
  onSubmit,
  loading = false,
  submitLabel = "Speichern",
  title = "Beitrag",
  error = null,
  success = null,
}) {
  const [form, setForm] = useState(initialValues);

  useEffect(() => {
    setForm(initialValues);
  }, [initialValues]);

  const handleChange = (field) => (event) => {
    setForm((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleBodyChange = (html) => {
    setForm((prev) => ({
      ...prev,
      body: html,
    }));
  };

  const handleSubmit = () => {
    onSubmit({
      ...form,
      published_at: form.published_at || null,
    });
  };

  return (
    <Box maxWidth="md" mx="auto" mt={4}>
      <Box>
        <Typography variant="h5" mb={3}>
          {title}
        </Typography>

        <Stack spacing={2}>
          <TextField
            label="Dachzeile"
            value={form.overline}
            onChange={handleChange("overline")}
            fullWidth
          />

          <TextField
            label="Überschrift"
            value={form.headline}
            onChange={handleChange("headline")}
            fullWidth
            required
          />

          <TextField
            label="Vorspann"
            value={form.teaser}
            onChange={handleChange("teaser")}
            multiline
            rows={6}
            fullWidth
          />

          <BlogBodyEditor value={form.body} onChange={handleBodyChange} />

          {success && <Alert severity="success">{success}</Alert>}

          {error && <Alert severity="error">{error}</Alert>}

          <Button variant="contained" onClick={handleSubmit} disabled={loading}>
            {loading ? "Speichern..." : submitLabel}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
